const formMaintenance = {
  formTitleCreate: 'Register new Maintenance',
  formTitleEdit: 'Maintenance Details',
  optionsLabel: 'Options',
  optionsMsg: 'Edit / Delete Maintenance',
  identifier: 'Identifier',
  description: 'Description',
  value: 'Value',
  company: 'Responsible Company',
  sendToMaintenanceDate: 'Expected Date to Send for Maintenance',
  returnFromMaintenanceDate: 'Expected Maintenance Return Date',
  warranty: 'Warranty Deadline',
  expiration: 'Expiration date',
};

export default formMaintenance;